import React, { SyntheticEvent, useMemo } from "react";

// Types
export type FilterOption = {
  key: number | string;
  value: number | string;
  text: string;
};

export type ButtonListSelectionProps = {
  options: FilterOption[];
  value: (number | string)[];
  onChange: (
    e: SyntheticEvent | null,
    data: { name?: string; value: (number | string)[] }
  ) => void;
  name?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  activeColor?: string;
  activeBgColor?: string;
  inactiveColor?: string;
  inactiveBgColor?: string;
  borderColor?: string;
};

const ButtonListSelection: React.FC<ButtonListSelectionProps> = (props) => {
  const {
    options = [],
    value = [],
    onChange,
    name,
    disabled = false,
    style,
    buttonStyle,
    activeColor = "#FFFFFF",
    activeBgColor = "#5DBCD2",
    inactiveColor = "#333333",
    inactiveBgColor = "transparent",
    borderColor = "rgba(34,36,38,.15)",
  } = props;

  const selectedSet = useMemo(() => new Set(value), [value]);

  const handleClick = (e: SyntheticEvent, optionValue: number | string) => {
    if (disabled) return;

    let newValue: (number | string)[];

    if (selectedSet.has(optionValue)) {
      newValue = value.filter((v) => v !== optionValue);
    } else {
      newValue = [...value, optionValue];
    }

    onChange(e, { name, value: newValue });
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "stretch",
        border: `1px solid ${borderColor}`,
        height: "38px",
        boxSizing: "border-box",
        ...style,
      }}
    >
      {options.map((option, index) => {
        const isSelected = selectedSet.has(option.value);
        const isLast = index === options.length - 1;

        return (
          <div
            key={option.key}
            onClick={(e) => handleClick(e, option.value)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0 1em",
              color: isSelected ? activeColor : inactiveColor,
              backgroundColor: isSelected ? activeBgColor : inactiveBgColor,
              fontWeight: isSelected ? "bold" : "normal",
              fontSize: "0.9em",
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.5 : 1,
              userSelect: "none",
              whiteSpace: "nowrap",
              transition: "background-color 0.15s, color 0.15s",
              borderRight: !isLast ? `1px solid ${borderColor}` : "none",
              ...buttonStyle,
            }}
          >
            {option.text}
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(ButtonListSelection);